// extracted by mini-css-extract-plugin
export default {"registration-button":"iS2xs","registrationButton":"iS2xs","disabled":"_3IsQk","link":"_1bC42"};